<template>
    
        <div class="progress-bars">
                <div class="progress-bar" :style="'width:'+width+'%'" v-for="(bullet, index) in sliderCount" :key="index">
                    <div class="progress" :class="{active: index==currentSlide}"></div>
                </div>
            </div>
 
  </template>
  
  <style scoped>
        /* Multiple Progress Bars */
.progress-bars {
  position: absolute;
  left: 50%;
  bottom: 123px;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  width: 50%;
  z-index: 3;
}

.progress-bar {
  width: 30%;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  overflow: hidden;
  margin: 0 5px;
}

.progress {
  height: 100%;
  width: 0;
  background-color: white;
  border-radius: 5px;
  /* transition: width 5s linear; */
}

.progress.active {
  transition: width 5s linear; 
  width: 100%;
}

    </style>
  <script>
  export default {
    props: {
        sliderCount: Number,
        activeSlide: {type: Number,       // Тип пропса
                      default: 100}
    },

    data:function(){

        return {
                    start:true
                                     
                }

    },

    computed:{

      currentSlide()
      {
        //console.log("выч"+this.activeSlide);

        if(this.start)
        {
          //this.start = false;

          setTimeout(() => {

            this.start = false;
            
          }, 500);

          return 100;
          
        }
        else
        {
          return this.activeSlide;
        }
        
      }  

    },

    // watch: {
    //     swiper: {

    //         immediate: true,

    //         handler(newSwiperRef) {
    //             if (newSwiperRef) {
    //             // Здесь можно выполнять действия с экземпляром Swiper
    //                 //this.updateProgress();
    //             }
    //         }
    //     }
    // },

    created: function() {

        this.width = 100/this.sliderCount;
        //this.activeSlide = 100;

        // setTimeout(() => {

        //     this.activeSlide = 0;
            
        // }, 100);
        //console.log(this.sliderCount);
    },

    methods:{


    }
  };
  </script>
  